import { render } from "./MainQuotes.vue?vue&type=template&id=e5cce842&scoped=true"
import script from "./MainQuotes.vue?vue&type=script&lang=js"
export * from "./MainQuotes.vue?vue&type=script&lang=js"

import "./MainQuotes.vue?vue&type=style&index=0&id=e5cce842&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5cce842"]])

export default __exports__